import { LinearProgress } from "@material-ui/core"
import PropTypes from "prop-types"
import { useContext } from "react"
import cuesColor from "~/assets/Icons/colored-plus.svg"
import contentColor from "~/assets/Icons/colored-video.svg"
import cues from "~/assets/Icons/feather-plus-circle.svg"
import content from "~/assets/Icons/feather-video.svg"
import seoColor from "~/assets/Icons/seo-colored-icon.svg"
import seo from "~/assets/Icons/seo-icon.svg"
import CategoryHeader from "~/components/Categories/CategoryHeader"
import CategorySeo from "~/components/Categories/CategorySeo"
import Box from "~/components/Common/Box"
import ContentTabs from "~/components/Common/ContentTabs"
import CategoryContext, { CategoryContainer } from "~/contexts/Category"
import Page from "~/pages/Page"
import Router from "~/router"

const Seo = ({ routes = [], ...rest }) => {
  const categoryId = +rest?.match?.params?.category_id

  const tabs = [
    {
      label: "Category",
      link: `/categories/${categoryId}`,
      icon1: content,
      icon2: contentColor,
    },
    {
      label: "Channels",
      link: `/categories/${categoryId}/channels`,
      icon1: cues,
      icon2: cuesColor,
    },
    {
      label: "Seo",
      link: `/categories/${categoryId}/seo`,
      icon1: seo,
      icon2: seoColor,
    },
  ]

  return (
    <Page>
      <CategoryContainer categoryId={categoryId}>
        <Box display="flex" flexDirection="column" height="100%">
          <Box flexShrink={0} flexGrow={0}>
            <CategoryHeader />
            <ContentTabs tabs={tabs} />
          </Box>
          {/* here */}
          <Box flexGrow={1} overflow="auto">
            <Page>
              <CategoryWrapper>
                <CategorySeo />
              </CategoryWrapper>
            </Page>
            <Router routes={routes} {...rest} />
          </Box>
        </Box>
      </CategoryContainer>
    </Page>
  )
}

const CategoryWrapper = ({ children }) => {
  const { categoryLoading, isLoadingLearningcategorys, isLoadingCourses } =
    useContext(CategoryContext)
  if (categoryLoading || isLoadingLearningcategorys || isLoadingCourses) {
    return <LinearProgress />
  } else {
    return children
  }
}

CategoryWrapper.propTypes = {
  children: PropTypes.node,
}

export default Seo
